import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import {
  setUserPermissions,
  clearUserPermissions,
} from '../../store/slices/userPermissions'
import { shouldUseNewPermissions } from '../../utils/devMode'

const PermissionsProvider = ({ children }) => {
  const dispatch = useDispatch()

  // Если новая система прав отключена, просто возвращаем children
  if (!shouldUseNewPermissions()) {
    return <>{children}</>
  }

  const loadPermissions = () => {
    // Проверяем есть ли данные пользователя в localStorage
    const accData = localStorage.getItem('acc')

    if (accData) {
      try {
        const userData = JSON.parse(accData)
        console.log(
          '🔄 Loading permissions from localStorage:',
          userData,
        )

        // Если у пользователя есть роль и права, устанавливаем их
        if (userData.role && userData.actions) {
          dispatch(
            setUserPermissions({
              role: userData.role,
              permissions: userData.actions,
            }),
          )
          console.log(
            '✅ Permissions loaded:',
            userData.role,
            userData.actions,
          )
        } else if (userData.role) {
          // Если есть только роль, устанавливаем права по умолчанию
          dispatch(
            setUserPermissions({
              role: userData.role,
              permissions: null, // Будет использована фабрика прав
            }),
          )
          console.log(
            '✅ Role loaded, using default permissions:',
            userData.role,
          )
        } else {
          // Если нет роли, устанавливаем права по умолчанию для viewer
          dispatch(
            setUserPermissions({
              role: 'viewer',
              permissions: null,
            }),
          )
          console.log('✅ Default viewer permissions set')
        }
      } catch (error) {
        console.error('❌ Error parsing user data:', error)
        // Очищаем некорректные данные
        localStorage.removeItem('acc')
        dispatch(clearUserPermissions())
      }
    } else {
      // Если нет данных пользователя, устанавливаем права по умолчанию для viewer
      dispatch(
        setUserPermissions({
          role: 'viewer',
          permissions: null,
        }),
      )
      console.log(
        '✅ No user data, default viewer permissions set',
      )
    }
  }

  useEffect(() => {
    loadPermissions()

    // Слушаем события принудительного обновления
    const handleForceUpdate = (event) => {
      console.log(
        '🔄 Force update event received:',
        event.detail,
      )
      dispatch(
        setUserPermissions({
          role: event.detail.role,
          permissions: event.detail.permissions,
        }),
      )
    }

    window.addEventListener(
      'forceUpdatePermissions',
      handleForceUpdate,
    )

    return () => {
      window.removeEventListener(
        'forceUpdatePermissions',
        handleForceUpdate,
      )
    }
  }, [dispatch])

  return <>{children}</>
}

export default PermissionsProvider
